import api from "./api";

export default {
  async getFretboardList(filters) {
    let querystring = "";
    if (filters) {
      const params = new URLSearchParams(filters);
      querystring = `?${params.toString()}`;
    }
    const response = await api.get(`/api/fretboards/${querystring}`);
    return response.data;
  },

  async getFretboard(id) {
    const response = await api.get(`/api/fretboards/${id}/`);
    return response.data;
  },

  async getFretboardChoices() {
    const response = await api.get(`/api/fretboards/choices/`);
    return response.data;
  },

  async saveFretboard(data) {
    let response;
    if (data.id) {
      response = await api.put(`/api/fretboards/${data.id}/`, data);
    } else {
      response = await api.post(`/api/fretboards/`, data);
    }
    return response.data;
  }
};
